/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
// Use consistent styling
import 'sanitize.css/sanitize.css';

// Import root app
import { App } from 'app';

import { HelmetProvider } from 'react-helmet-async';

import { configureAppStore } from 'store/configureStore';

import { SocketContextProvider } from 'utils/context/SocketContext';
import { HighlightedMessageProvider } from 'utils/context/HighlightedMessageContext';
import { BrowserRouter } from 'react-router-dom';
import { initializeAnalytics } from 'utils/googleAnalytics';
import { MobileNavigationProvider } from 'utils/context/NavigateContext';
import { FacebookProvider } from 'utils/context/FacebookContext';
import { NavigationProvider } from 'utils/context/NavigationContext';
import { ThemeProvider } from 'utils/context/ThemeProvider';
import { TooltipProvider } from '@heltarchat/ui';
import { CallProvider } from 'utils/context/CallContext';

const store = configureAppStore();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

initializeAnalytics();

root.render(
  <Provider store={store}>
    <HelmetProvider>
      <React.StrictMode>
        <SocketContextProvider>
          <BrowserRouter>
            <NavigationProvider>
              <HighlightedMessageProvider>
                <MobileNavigationProvider>
                  <CallProvider>
                    <FacebookProvider>
                      <ThemeProvider defaultTheme='system'>
                        <TooltipProvider delayDuration={100}>
                          <App />
                        </TooltipProvider>
                      </ThemeProvider>
                    </FacebookProvider>
                  </CallProvider>
                </MobileNavigationProvider>
              </HighlightedMessageProvider>
            </NavigationProvider>
          </BrowserRouter>
        </SocketContextProvider>
      </React.StrictMode>
    </HelmetProvider>
  </Provider>,
);
